import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Icon } from '@src-common/view/components/Icon';

import s from './DriverPartnerContract.module.css';

interface IProps {
  value: boolean;
  name: string;
  onChange: (value: boolean, params: { value: boolean; name: string }) => void;
}

const DriverPartnerContract = ({ value, name, onChange }: IProps) => {
  const handleClickRevoke = useCallback(() => {
    onChange(false, { value: false, name });
  }, [name, onChange]);

  const handleClickApprove = useCallback(() => {
    onChange(true, { value: true, name });
  }, [name, onChange]);

  return (
    <div className={s.root}>
      <div className={s.terms}>
        <FormattedMessage
          defaultMessage="Я гарантирую наличие Трудового договора с этим водителем и сразу же уведомлю Wheely при его расторжении"
          id="djB/+k"
          description="RU: driver profile"
        />
        {value && (
          <button className={s.revoke} onClick={handleClickRevoke}>
            <FormattedMessage
              defaultMessage="Отозвать"
              id="ru3jPM"
              description="RU: driver profile"
            />
          </button>
        )}
      </div>
      <div className={s.right}>
        {value ? (
          <Icon icon={'checkmark-in-circle'} color={'#4cd964'} size="24px" />
        ) : (
          <button className={s.approve} onClick={handleClickApprove}>
            <FormattedMessage
              defaultMessage="Подтвердить"
              id="DP6fES"
              description="RU: driver profile"
            />
          </button>
        )}
      </div>
    </div>
  );
};

export { DriverPartnerContract };
